import types from '../types'

export const getAuthKey = (database, orgId) => (dispatch, getState) => {
  const dbRef = database
      .ref(`organizations/${orgId}/activeApis/genericFormApi/authToken`)
  return dbRef.get()
      .then((snapshot) => {
        const val = snapshot.val()
        if (val) {
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              authKey: val,
            },
          })
          return val
        }
      })
      .catch((err) => {
        console.log('err: ', err)
      })
}
